/* unplugin-vue-components disabled */import { render } from "./publicWelfare.vue?vue&type=template&id=217fd8c2&scoped=true"
import script from "./publicWelfare.vue?vue&type=script&lang=js"
export * from "./publicWelfare.vue?vue&type=script&lang=js"

import "../../assets/css/init/column.less?vue&type=style&index=0&id=217fd8c2&lang=less&scoped=true"
import "../../assets/css/about/about.less?vue&type=style&index=1&id=217fd8c2&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217fd8c2"]])

export default __exports__